import React from 'react';
import "./Panel.sass";
import Shape from "../Shape/Shape";
import Image from "../Image/Image";
import Content from "../Content/Content";
import TextItem from "../TextItem/TextItem";
import _ from 'lodash';

const Panel = ({data}) => {
    const {elements, style} = data;
    return (
        <div id={data.id}
             className={data.classNames ? "Panel " + data.classNames : "Panel"}
             style={style || {}}>
            {elements.map((element, index) => {
                if (!element.id) {
                    element.id = _.uniqueId("panel_item" + index + "_");
                }
                switch (element.type) {
                    case 'shape':
                        return <Shape data={element}
                                      key={index}/>;
                        break;
                    case 'image':
                        return <Image data={element}
                                      key={index}/>;
                        break;
                    case 'content':
                        return <Content data={element}
                                        key={index}/>;
                        break;
                    case 'text':
                        return <TextItem data={element}
                                         key={index}/>;
                        break;
                    default:
                        return null;
                }
            })}
        </div>
    );
};

export default Panel;